import { PublicClientApplication } from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import React from "react";
import { LoginPage } from "../../LoginPage";
import { loginSilentRequest } from "./AuthConfig";

interface Props {
  msalInstance: PublicClientApplication;
  children: React.ReactNode;
}

export const AuthMsalGate: React.FC<Props> = ({ children, msalInstance }) => {
  const onPressLogin = async () => {
    await msalInstance.initialize();
    msalInstance.loginRedirect(loginSilentRequest);
  };

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage onPressLogin={onPressLogin} />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
};
